import { createContext, PropsWithChildren, useMemo, useState } from "react";
import { useFetchPhases } from "../api/hooks";
import { PhaseResponse } from "../api/client/Api";

type RootContextType = {
  phases: PhaseResponse[];
  selectedPhaseId?: string;
  setSelectedPhaseId: (phaseId: string | undefined) => void;
  selectedPhaseType: "regular" | "playoff" | "final";
  setSelectedPhaseType: (type: "regular" | "playoff" | "final") => void;
  filteredPhases: PhaseResponse[];
};

export const RootContext = createContext<RootContextType>({
  phases: [],
  selectedPhaseId: undefined,
  setSelectedPhaseId: (phaseId: string | undefined) => {},
  selectedPhaseType: "regular",
  setSelectedPhaseType: (type: "regular" | "playoff" | "final") => {},
  filteredPhases: [],
});

export const RootProvider = ({ children }: PropsWithChildren) => {
  const [selectedPhaseId, setSelectedPhaseId] = useState<string>();
  const [selectedPhaseType, setSelectedPhaseType] = useState<
    "regular" | "playoff" | "final"
  >("regular");

  const { data: phases } = useFetchPhases();

  const filteredPhases = useMemo(() => {
    if (!phases) return [];
    return phases.filter((phase) => phase.type === selectedPhaseType);
  }, [phases, selectedPhaseType]);

  const value = useMemo(
    () => ({
      phases: phases || [],
      selectedPhaseId,
      setSelectedPhaseId,
      selectedPhaseType,
      setSelectedPhaseType,
      filteredPhases,
    }),
    [
      phases,
      selectedPhaseId,
      setSelectedPhaseId,
      selectedPhaseType,
      setSelectedPhaseType,
      filteredPhases,
    ]
  );

  return <RootContext.Provider value={value}>{children}</RootContext.Provider>;
};
